export interface IProfessional
{
    firstName: string;
    lastName: string;
    npi:string;
}

export class Professional implements IProfessional
{
    constructor
    (
        public firstName: string,
        public lastName: string,
        public npi: string
    )
    {
        
    }
}